import React, { useState, useRef, useCallback } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
  CustomRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { resetPassword } from '../../api/auth';
import './ResetPasswordForm.scss';
import { Popup } from 'devextreme-react';
import axios from 'axios';
import GlobalParams from '../../helpers/GlobalParams';

const notificationText = 'We\'ve sent a link to reset your password. Check your inbox.';

export default function ResetPasswordForm() {
  const [vsChangePass, setVsChangePass] = useState(false);
  const [vsSendOTPForm, setVsSendOTPForm] = useState(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [OTP, setOTP] = useState(null);
  const formData = useRef({ email: '', password: '' });
  const otpStore = useRef({ otp: '' });
  const changePassStore = useRef({ password: '', confirm_password: '' });

  const onRequestOTP = async (email) => {
    try {
      // Send request using axios
      const response = await axios.post(
        GlobalParams.LoginApiUrlPrefixV2 + 'forgot-cp-password',
        {
          'email': email,
        },
        {
          headers: {
            Authorization: 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );

      if (response.status === 200) {
        console.log(response);
        console.log(response.data.data.contact_email);
        setOTP(response.data.data.Otp);
        setpopupOTPVisible(true);
        setLoading(false);
        notify("Security Code successfully sent to: " + response.data.data.contact_email, 'success', 10000);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const { email } = formData.current;
    setLoading(true);

    onRequestOTP(email);
  }, []);

  const onVerifyOTP = async (email, otp) => {
    try {
      // Send request using axios
      setOTP(otp);
      const response = await axios.post(
        GlobalParams.ApiUrlPrefix + 'confirm-otp',
        {
          'otp': otp,
          'email': email
        },
        {
          headers: {
            Authorization: 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );

      if (response.status === 201 || response.status === 200) {
        console.log(response);
        setpopupOTPVisible(false);
        setVsSendOTPForm(false);
        setVsChangePass(true);
        setLoading(false);
        notify("Security Code Successfully Validated", 'success', 10000);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  const onChangePass = async (email, password) => {
    try {
      // Send request using axios
      const response = await axios.post(
        GlobalParams.LoginApiUrlPrefixV2 + 'create-cp-password',
        {
          'email': email,
          'otp': OTP,
          'password': password,
          'confirm_password': password
        },
        {
          headers: {
            Authorization: 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setLoading(false);
      if (response.status === 201 || response.status === 201) {
        navigate('/login');
        notify("Login with New Password", 'success', 2500);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  const onSubmitPass = useCallback(async (e) => {
    e.preventDefault();
    const { email } = formData.current;
    const { password } = changePassStore.current;
    setLoading(true);

    const response = await onChangePass(email, password);

  }, [navigate]);

  ///Security code pop up/////
  const [popupOTPVisible, setpopupOTPVisible] = useState(false);
  const hideOTPButtonClick = () => {
    setpopupOTPVisible(false);
  };
  const emptyItemConfig = {
    itemType: 'empty',
  };
  const doVerifyOTP = useCallback(async (e) => {
    e.preventDefault();
    const { otp } = otpStore.current;
    const { email } = formData.current;
    setLoading(true);
    onVerifyOTP(email, otp);
  }, []);
  //end of security code pop up//

  const confirmPassword = useCallback(
    ({ value }) => value === changePassStore.current.password,
    []
  );

  return (
    <div>
      {/*Create OTP popup */}
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupOTPVisible}
          title={'Security Code'}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideOTPButtonClick}
        >

          <div>
            <form onSubmit={doVerifyOTP}>
              <Form formData={otpStore.current} >

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <Item
                  dataField="otp"
                  editorType="dxTextBox"
                >
                  {true && <RequiredRule message="Security Code is required" />}
                  <Label text='Security Code' />
                </Item>


                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <ButtonItem
                >
                  <ButtonOptions type='danger' text="SUBMIT" icon='save' useSubmitBehavior={true} />
                  <span className="dx-button-text">
                    {
                      loading
                        ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                        : 'Continue'
                    }
                  </span>
                </ButtonItem>

              </Form>
            </form>
          </div>

        </Popup>
      </div>
      <form className={'reset-password-form'} onSubmit={onSubmit}>
        <Form formData={formData.current} disabled={loading} visible={vsSendOTPForm}>
          <Item
            dataField={'email'}
            editorType={'dxTextBox'}
            editorOptions={emailEditorOptions}
          >
            <RequiredRule message="Email is required" />
            <EmailRule message="Email is invalid" />
            <Label visible={false} />
          </Item>
          <ButtonItem>
            <ButtonOptions
              elementAttr={submitButtonAttributes}
              width={'100%'}
              type={'default'}
              useSubmitBehavior={true}
            >
              <span className="dx-button-text">
                {
                  loading
                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                    : 'Reset my password'
                }
              </span>
            </ButtonOptions>
          </ButtonItem>
          <Item>
            <div className={'login-link'}>
              Return to <Link to={'/login'}>Sign In</Link>
            </div>
          </Item>
        </Form>
      </form>

      {/*Form to display change of Password */}
      <div>
        <form onSubmit={onSubmitPass}>
          <Form formData={changePassStore.current} disabled={loading} visible={vsChangePass}>
            <Item
              dataField={'password'}
              editorType={'dxTextBox'}
              editorOptions={passwordEditorOptions}
            >
              <RequiredRule message="Password is required" />
              <Label visible={false} />
            </Item>
            <Item
              dataField={'confirmedPassword'}
              editorType={'dxTextBox'}
              editorOptions={confirmedPasswordEditorOptions}
            >
              <RequiredRule message="Password is required" />
              <CustomRule
                message={'Passwords do not match'}
                validationCallback={confirmPassword}
              />
              <Label visible={false} />
            </Item>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'default'}
                useSubmitBehavior={true}
              >
                <span className="dx-button-text">
                  {
                    loading
                      ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                      : 'Continue'
                  }
                </span>
              </ButtonOptions>
            </ButtonItem>
          </Form>
        </form>
      </div>


    </div>
  );
}

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email' };
const submitButtonAttributes = { class: 'submit-button' };

const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };
const confirmedPasswordEditorOptions = { stylingMode: 'filled', placeholder: 'Confirm Password', mode: 'password' };
